<div>
  <button nz-button [nzType]="data.type">{{ data.title }}</button>
</div>